import login from './login';

export default {
  language: 'cs-CZ',
  country: 'cz',
  name: 'Čeština',
  embeddedLocale: login,
};
